// Library methods
import { useTranslation } from "react-i18next";

// Components
import { Box, Grid, Typography } from "@mui/material";

const StereopsisResults = ({ stereopsisResults, getFormattedResponse }) => {
  // internationalization
  const { t } = useTranslation();

  return (
    <Box
      border="1px solid black"
      borderRadius="8px"
      p="20px"
      sx={{ width: "100%", height: "100%", pageBreakBefore: "always" }}
    >
      <Typography mb="20px">{t("word_stereopsis_results")}</Typography>
      <Box display="flex" flexDirection="column" gap="20px">
        {stereopsisResults?.map((stereopsisResult, resultIndex) => (
          <Grid
            key={resultIndex}
            item
            xs={12}
            display="flex"
            flexDirection="column"
            gap="20px"
            sx={{
              pageBreakAfter:
                resultIndex !== stereopsisResults.length - 1
                  ? "always"
                  : "auto",
            }}
          >
            <Box display="flex" justifyContent="space-around">
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap="8px"
                sx={{ width: "100%", height: "100%" }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight={600}
                  sx={{ textTransform: "capitalize" }}
                >
                  {t("left_eye_image")}
                </Typography>
                <img
                  alt="stereopsis results left eye slide"
                  height="70%"
                  width="70%"
                  style={{
                    borderRadius: "50%",
                    border: "1px solid black",
                  }}
                  src={`data:image/png;base64,${stereopsisResult?.slideSet?.leftEyeImage}`}
                />
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap="8px"
                sx={{ width: "100%", height: "100%" }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight={600}
                  sx={{ textTransform: "capitalize" }}
                >
                  {t("right_eye_image")}
                </Typography>
                <img
                  alt="stereopsis results right eye slide"
                  height="70%"
                  width="70%"
                  style={{
                    borderRadius: "50%",
                    border: "1px solid black",
                  }}
                  src={`data:image/png;base64,${stereopsisResult?.slideSet?.rightEyeImage}`}
                />
              </Box>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="space-around"
              gap="20px"
            >
              {stereopsisResult?.responses?.map((response, index) => {
                const isCorrect =
                  response.responseData === response.expectedResponse;
                return (
                  <Box
                    key={response.questionType}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    textAlign="center"
                    gap="4px"
                  >
                    <Typography fontWeight={600} fontSize="14px">
                      {index + 1}. {t(response.questionType)}
                    </Typography>
                    <Typography fontSize="14px">
                      {`${t("word_response")}: ${getFormattedResponse(response.responseData)}`}
                    </Typography>
                    <Typography
                      fontSize="14px"
                      color={isCorrect ? "#13A321" : "#B21515"}
                    >
                      {`${t("word_expected_response")}: ${getFormattedResponse(response.expectedResponse)}`}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Grid>
        ))}
      </Box>
    </Box>
  );
};

export default StereopsisResults;
